import { CircularProgress, Tooltip } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useVideoTooltip } from "common/customHook/useVideoTootip";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Chert from "./chart";
import { useTheme, useMediaQuery } from "@mui/material";

const useStyles = makeStyles(() => ({
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));

export default function Index({ tip }) {
  const [setvideo, htmlCodeVideo] = useVideoTooltip();
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [state, setState] = useState({
    systematic_risk: 0,
    unsystematic_risk: 0,
  });

  const riskSystematicReducer = useSelector(
    (state) => state.reducer_portfolio_portfolioRisk_systematic,
  );

  useEffect(() => {
    if (Object.keys(riskSystematicReducer.data).length) {
      setState({
        systematic_risk: 0,
        unsystematic_risk: 0,
        ...riskSystematicReducer.data,
      });
    }
  }, [riskSystematicReducer]);

  useEffect(() => {
    setvideo("/media/video/Systematic Vs Unsystematic Risk 2.mp4");
  }, []);

  const loadingReducer = useSelector((state) => state.loading);
  let flag = !(!state.unsystematic_risk && !state.systematic_risk);

  return (
    <>
      {/* {
                !flag && (
                    <div className="absolute top-0 left-0 right-0 bottom-0 flex justify-center items-center text-gray-400 bg-white opacity-50">
                     در این بازه زمانی معامله‌ای انجام نشده است. لطفا بازه زمانی را تغییر دهید. 
                    </div>
                )
            } */}
      <div className="grid grid-cols-12">
        <div className="col-span-12  lg:col-span-4 ">
          <div className="flex justify-start align-middle mb-3 mt-2">
            <h1 className="pr-3">ریسک</h1>
            <Tooltip
              className={`mx-2`}
              title={<p className="p-2 m-0">{tip}</p>}
              placement={isMobile ? "bottom" : "left"}
              arrow
              classes={{ tooltip: classes.tooltip }}
              enterTouchDelay={1}
            >
              {/* <Info
                               style={{
                                color: "rgb(13, 158, 13)",
                                float: "left",
                                fontSize: "1.3rem",
                              }}

                              /> */}
              <img alt={"tooltip"} src="/media/image/Group 12485.png" />
            </Tooltip>
            <span className={`mt-1 hover:cursor-pointer`}>{htmlCodeVideo}</span>
          </div>
          <div className="text-sm text-gray-700 p-5">
            نمودار پیش رو، ریسک سیستماتیک و غیر سیستماتیک شما در آخرین روز را
            نمایش می‌دهد.
          </div>
        </div>
        <div className="col-span-12  lg:col-span-4">
          <div className="my-10 w-[80%] m-auto pt-6">
            <div className="flex justify-between w-full text-gray-300">
              <p className="text-black">نوع ریسک</p>
              <p className="px-4 text-black">درصد</p>
            </div>
            <div className="flex justify-between w-full border-b  py-2">
              <div className="flex mt-3 align-center">
                <div className="bg-[#d9a026] w-5 h-5 rounded-full ml-2"></div>
                <div>
                  <p> سیستماتیک</p>
                </div>
              </div>
              <div className="bg-[#2a8ede] px-2 pt-1 w-auto rounded-full text-white h-7 text-center mt-2">
                <p style={{ direction: "ltr" }}>
                  {`${
                    state.systematic_risk
                      ? (
                          (state.systematic_risk /
                            (state.systematic_risk + state.unsystematic_risk)) *
                          100
                        ).toFixed(2)
                      : "0.00"
                  }%`}
                </p>
              </div>
            </div>
            <div className="flex justify-between w-full border-b  py-2">
              <div className="flex mt-3 align-center">
                <div className="bg-[#8bd926] w-5 h-5 rounded-full ml-2"></div>
                <div>
                  <p>غیر سیستماتیک</p>
                </div>
              </div>
              <div className="bg-[#2a8ede] px-2 pt-1 w-auto rounded-full text-white h-7 text-center mt-2">
                <p style={{ direction: "ltr" }}>
                  {`${
                    state.unsystematic_risk
                      ? (
                          (state.unsystematic_risk /
                            (state.systematic_risk + state.unsystematic_risk)) *
                          100
                        ).toFixed(2)
                      : "0.00"
                  }%`}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-12  lg:col-span-4">
          {loadingReducer.loading ? (
            <div className="h-full w-full flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <div
              style={{ direction: "ltr" }}
              className={
                "h-[200px] md:h-[300px] flex w-[100%] md:w-[60%] lg:w-[80%]  m-auto "
              }
            >
              <Chert data={state} flagLabel={flag} />
            </div>
          )}
        </div>
      </div>
    </>
  );
}
